import styled from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import React from "react";
import Box from "@onnit-js/ui/components/box/Box";
import { Img } from "@onnit-js/ui/components/image";
import { Text } from "@onnit-js/ui/components/text";
import { ifProp } from "styled-tools";
import { ImageProps } from "@onnit-js/ui/components/image/Image";
import Button, { ButtonProps } from "@onnit-js/ui/components/button/Button";
import { stripTags } from "../../../lib/utils";
import { Trial } from "../trials";

interface TrialButtonProps {
    isOpen: boolean;
    trial: Trial;
    imgUrl: string;
    onClick: (event: any) => void;
    ariaControlsId: string;
}

interface TrialButtonContainerProps extends ButtonProps {
    isOpen: boolean;
}

const TrialButtonContainer = styled(Button)<TrialButtonContainerProps>`    

    background-color: ${ifProp("isOpen", "#161617", "#606060")};
    cursor: pointer;
    transition: box-shadow 200ms;
     box-sizing: border-box;
    border-width: 2px;
    border-style: solid;
    border-radius: 6px;
    line-height: 1.125;
    text-decoration: none;
    vertical-align: middle;
    cursor: pointer;
    position: relative;
    text-align: center;
    border-color: "#4f4f4f";
       font-weight: ${themeGet("fontWeights.bold")};    
    font-family: ${themeGet("fonts.primary")};
    font-size: ${themeGet("fontSizes.2")}px;
    /*opacity: ${ifProp("isOpen", "100%", "50%")};*/
    user-select: none;
    -webkit-font-smoothing: antialiased;
    -webkit-appearance: none;
    -webkit-appearance: none !important;
    box-shadow: 2px 2px 0 0 rgba(0,0,0,.1875);
        
    &:hover {
        opacity: 90%;
    }
`;

interface TrialButtonImage extends ImageProps {
    isOpen: boolean;
}

const TrialButtonImage = styled(Img)<TrialButtonImage>`
    
    border-radius: 50%;
    opacity: ${ifProp("isOpen", "100%", "50%")};
`;

const TrialButton: React.FC<React.PropsWithChildren<React.PropsWithChildren<TrialButtonProps>>> = (
    {
        imgUrl,
        isOpen,
        onClick,
        trial,
        ariaControlsId
    }) => {
    const { productId, btnImageParams, title } = trial;
    const altTitle = stripTags(title);

    return (

        <TrialButtonContainer
            as="button"
            aria-disabled={isOpen}
            aria-controls={ariaControlsId}
            onClick={onClick}
            isOpen={isOpen}
        >
            <Box
                as="span"
                minHeight="80px"
                display="grid"
                gridTemplateColumns={["50% 50%", "50% 50%", "50% 50%", "50% 50%", "100px 100px"]}
                alignContent="center"
                justifyContent="center"
                py={2}
            >
                <Box
                    as="span"
                    width={["auto", "auto", "auto", "60%", "100%"]}
                    maxWidth="80px"
                    maxHeight="80px"
                    display="block"
                    mx="auto"
                >
                    <TrialButtonImage
                        lazyLoad={false}
                        isOpen={isOpen}
                        src={`${imgUrl}/authority/${productId}.png?${btnImageParams}`}
                        alt={altTitle}
                        aria-hidden="true"
                    />
                </Box>
                <Box
                    as="span"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Text
                        textAlign="left"
                        typeStyle="title04"
                        pl={2}
                        fontSize={10}
                        fontWeight="black"
                        textTransform="uppercase"
                        color="white"
                        dangerouslySetInnerHTML={{ __html: trial.btnTitle }}
                    />
                </Box>
            </Box>
        </TrialButtonContainer>
    );
};

export default TrialButton;
